module.exports = __webpack_public_path__ + "static/img/mini-bus-white.711c9f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/mini-bus-white.svg
// module id = os3l
// module chunks = 82